import { ICountryMySuffix } from 'src/app/shared/model//country-my-suffix.model';
import { AddressMySuffix, IAddressMySuffix, State } from 'src/app/shared/model/address-my-suffix.model';
import { FileDataMySuffix, IFileDataMySuffix } from 'src/app/shared/model/file-data-my-suffix.model';
import { ISurveyAssociationMySuffix } from './survey-association-my-suffix.model';


export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export const enum TaxResponsibilityType {
    SELF = 'SELF',
    UNDERWRITER = 'UNDERWRITER',
    BROKER = 'BROKER',
    CLIENT = 'CLIENT'
}

export interface IInsuranceCompanySurveyAssociationPriority {
    id?: number;
    surveyAssociationDTO?: ISurveyAssociationMySuffix;
    priority?: number
}

export class InsuranceCompanySurveyAssociationPriority implements IInsuranceCompanySurveyAssociationPriority {

    constructor(
        public id?: number,
        public surveyAssociationDTO?: ISurveyAssociationMySuffix,
        public priority?: number
    ) { }

}

export interface ISurveyAssociationPriority {
    id?: number;
    name?: string;
}

export class SurveyAssociationPriority implements ISurveyAssociationPriority {
    constructor(
        public id?: number,
        public name?: string
    ) { }
}

export interface IInsuranceCompanyMySuffix {
    id?: number;
    name?: string;
    primaryContactNumber?: string;
    pContactCountryCode?: number;
    primaryContactCountryCode?: ICountryMySuffix;
    secondaryContactNumber?: string;
    primaryEmailAddress?: string;
    secondaryEmailaddress?: string;
    activeStatus?: ActiveStatus;
    signatureId?: number;
    companyAddressId?: number;
    primaryContactCountryId?: number;
    secondaryContactCountryId?: number;
    licensedNonAdmitCountries?: ICountryMySuffix[];
    excludeCountries?: ICountryMySuffix[];
    companyAddressDTO?: IAddressMySuffix;
    fileDTO?: IFileDataMySuffix;
    signature?: any;
    taxResponsibility?: TaxResponsibilityType;
    taxIdentificationNumber?: string;
    noSurveyRequired?: number;
    lastModifiedBy?: string;
    createdByUserRole?: string;
    lastModifiedByUserRole?: string;
    surveyAssociationPriorityInfoDTO?: IInsuranceCompanySurveyAssociationPriority[];
    fromEffectiveDate?: string;
    isAccessPlatform?: boolean;
    isUserExisted?: boolean;
    excludeStates?: State[];
    licensedNonAdmitStates?: State[];
    nameWithAddress?: string;
    authorizationLimit?: number;
    limitCurrency?: number;
    limitCurrencyName?: string;
    underwriterInsurerId?: number;
    accessStatus?: string
    loginEmailAddress?: string;
}

export class InsuranceCompanyMySuffix implements IInsuranceCompanyMySuffix {
    constructor(
        public id?: number,
        public name?: string,
        public primaryContactNumber?: string,
        public pContactCountryCode?: number,
        public primaryContactCountryCode?: ICountryMySuffix,
        public secondaryContactNumber?: string,
        public primaryEmailAddress?: string,
        public secondaryEmailaddress?: string,
        public activeStatus?: ActiveStatus,
        public signatureId?: number,
        public companyAddressId?: number,
        public primaryContactCountryId?: number,
        public secondaryContactCountryId?: number,
        public licensedNonAdmitCountries?: ICountryMySuffix[],
        public excludeCountries?: ICountryMySuffix[],
        public companyAddressDTO?: IAddressMySuffix,
        public fileDTO = new FileDataMySuffix(),
        public signature?: any,
        public taxResponsibility: TaxResponsibilityType = TaxResponsibilityType.SELF,
        public taxIdentificationNumber?: string,
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public lastModifiedByUserRole?: string,
        public surveyAssociationPriorityInfoDTO: IInsuranceCompanySurveyAssociationPriority[] = [],
        public fromEffectiveDate?: string,
        public isAccessPlatform: boolean = false,
        public isUserExisted: boolean = false,
        public noSurveyRequired: number = 0,
        public excludeStates?: State[],
        public licensedNonAdmitStates?: State[],
        public nameWithAddress?: string,
        public authorizationLimit?: number,
        public limitCurrency?: number,
        public limitCurrencyName?: string,
        public underwriterInsurerId?: number,
        public accessStatus?: string

    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
        this.taxResponsibility = TaxResponsibilityType.SELF;
        this.companyAddressDTO = new AddressMySuffix();
    }
}
